import { V2_API_PREFIX, V2_COMPANY_ROUTE } from '@constants'

export const API_TAX_LIST_URL = `${V2_COMPANY_ROUTE}monthly-taxes`
export const API_TAX_BACKGROUND_ACTION_URL = `${V2_COMPANY_ROUTE}monthly-taxes/actions`
export const API_TAX_REDICT_URL = `${V2_COMPANY_ROUTE}monthly-taxes/predict`

// Activity codes are a large list served by a dedicated endpoint (mirrors the
// accountingplus `useCompanyActivities` hook), not the static init config.
export const API_COMPANY_ACTIVITY_CODES_URL = `${V2_API_PREFIX}company-activity-code`
